// removed by extract-text-webpack-plugin
module.exports = {"root":"root__2Iu-q","extra":"extra__3AGNr","viz":"viz__2KgWY","vizInner":"vizInner__2f-FV","ieWrap":"ieWrap__2afSC","imageSizer":"imageSizer__1Xbzh","imageWrap":"imageWrap__3ybaK","wrap":"wrap__joIXC","canvas":"canvas__1uWF-","sections":"sections__2a7md","labels":"labels__27vaj"};


//////////////////
// WEBPACK FOOTER
// ./components/RomanceBreakdownViz/style.css
// module id = 0aRJ
// module chunks = 0